export const getFileExtension = (filename: string) => {
  if (!filename || filename.indexOf(".") === -1) {
    return "";
  }

  const extension = filename.split(".").pop();
  if (!extension) {
    return "";
  }

  return extension.toLowerCase();
};
